(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["aurea-bilingual-headings"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.aureaBilingualHeadingsReady) return;
    window.aureaBilingualHeadingsReady = true;

    const headingTranslations = new Map([
      ['Shop by Categories', 'Mua sắm theo danh mục'],
      ['Premium Towels', 'Khăn cao cấp'],
      ['Bath Salts', 'Muối tắm'],
      ['Premium Bath Salts', 'Muối tắm cao cấp'],
      ['Himalayan Lamp', 'Đèn đá muối Himalaya'],
      ['Massage Stone', 'Đá massage'],
      ['America’s #1 Trusted Choice for Hand Towels', 'Lựa chọn khăn tay đáng tin cậy hàng đầu tại Mỹ'],
      ["America's #1 Trusted Choice for Hand Towels", 'Lựa chọn khăn tay đáng tin cậy hàng đầu tại Mỹ'],
      ['Wholesale Wellness Essentials', 'Sản phẩm chăm sóc sức khỏe giá sỉ'],
      ['Wholesale Towels & Bath Salts for Every Business', 'Khăn và muối tắm giá sỉ cho mọi doanh nghiệp'],
      ['Our Houston Based Warehouse', 'Kho hàng của chúng tôi tại Houston'],
      ['Large Inventory', 'Nguồn hàng dồi dào'],
      ['Houston Based', 'Có trụ sở tại Houston'],
      ['Free Nationwide Shipping', 'Miễn phí vận chuyển toàn quốc'],
      ['Bulk Quantities', 'Nhận đơn số lượng lớn'],
      ['Premium Bath Salt Manufactured for Professional Results', 'Muối tắm cao cấp cho hiệu quả chuyên nghiệp'],
      ['Premium Towel Manufacturing Supplier', 'Nhà cung cấp sản xuất khăn cao cấp'],
      ['MANUFACTURING & WHOLESALE SUPPLY', 'SẢN XUẤT & CUNG ỨNG SỈ'],
      ['Our Factory Insides', 'Bên trong nhà máy của chúng tôi'],
      ['Free Shipping Nationwide', 'Miễn phí vận chuyển trên toàn nước Mỹ'],
      ['Buy More Pay Less', 'Mua nhiều, tiết kiệm hơn'],
      ['Filters', 'Bộ lọc'],
      ['Collections', 'Danh mục'],
      ['Free shipping, wherever business is.', 'Miễn phí vận chuyển đến mọi doanh nghiệp.'],
      ['Product description', 'Mô tả sản phẩm'],
      ['Shipping & Return', 'Vận chuyển & đổi trả'],
      ['Packaging & Shipping Details', 'Chi tiết đóng gói & vận chuyển'],
      ['Key Benefits', 'Lợi ích nổi bật'],
      ['Why Choose Our Premium Hand Towels?', 'Vì sao nên chọn khăn tay cao cấp của chúng tôi?'],
      ['Care Instructions', 'Hướng dẫn bảo quản'],
      ['Perfect For', 'Phù hợp cho'],
      ['You Might Also Like', 'Có thể bạn cũng thích'],
      ['Recently Viewed Products', 'Sản phẩm đã xem gần đây'],
      ['Categories', 'Danh mục'],
      ['Information', 'Thông tin'],
      ['Contact Us', 'Liên hệ'],
      ['About Us', 'Về chúng tôi'],
      ['Frequently Asked Questions', 'Câu hỏi thường gặp'],
      ['Search', 'Tìm kiếm'],
      ['Shopping Cart', 'Giỏ hàng']
    ]);

    const supportingTranslations = new Map([
      ['America’s #1 Trusted Choice for All bussiness', 'Lựa chọn đáng tin cậy hàng đầu cho mọi doanh nghiệp'],
      ["America's #1 Trusted Choice for All bussiness", 'Lựa chọn đáng tin cậy hàng đầu cho mọi doanh nghiệp'],
      ['Shop Towels by Industry', 'Chọn khăn theo ngành nghề'],
      ['Quality essentials for spas, salons, wellness businesses & bulk buyers.', 'Sản phẩm chất lượng cho spa, salon, doanh nghiệp chăm sóc sức khỏe và khách mua số lượng lớn.'],
      ['Year-around product availability', 'Hàng có sẵn quanh năm'],
      ['Year-round product availability', 'Hàng có sẵn quanh năm'],
      ['Responsive wholesale support', 'Hỗ trợ khách sỉ nhanh chóng'],
      ['On all products', 'Áp dụng cho tất cả sản phẩm'],
      ['Built for wholesale buyers', 'Dành cho khách hàng mua sỉ'],
      ['BUILT FOR BUSINESS ORDERS', 'THIẾT KẾ CHO ĐƠN HÀNG DOANH NGHIỆP'],
      ['BUSINESS ORDERING MADE EASIER', 'ĐẶT HÀNG DOANH NGHIỆP DỄ DÀNG HƠN'],
      ['Case & Pallet Pricing Available', 'Có giá theo thùng và pallet']
    ]);

    const headingSelector = [
      '#MainContent .m-section__heading',
      '#MainContent .m-richtext__title',
      '#MainContent .m-collection-page-header__title',
      '#MainContent .m-sidebar--title',
      '#MainContent .m-filter--widget-title',
      '#MainContent .m-page-header__title',
      '#MainContent .m-page-title',
      '#MainContent .aurea-industry-head h2',
      '#MainContent .aurea-feature-item h3',
      '#MainContent .aurea-business-top h2',
      '#MainContent .aurea-business-mid h3',
      '#MainContent .m-custom__block h1',
      '#MainContent .m-custom__block h2',
      '#MainContent .m-custom__block h3',
      '#MainContent .m-tabs__header-inner .m-tab-header',
      '#MainContent .m-product-tabs .m-tab-header',
      '#MainContent .m-select-custom--trigger-text',
      '#MainContent .rte > h2',
      '#MainContent .rte > h3'
    ].join(',');

    const supportingSelector = [
      '#MainContent .m-section__subheading',
      '#MainContent .m-section__description',
      '#MainContent .aurea-industry-head p',
      '#MainContent .aurea-feature-item p',
      '#MainContent .aurea-free-ship-top__eyebrow',
      '#MainContent .aurea-ship-feature__eyebrow',
      '#MainContent .aurea-free-ship-top__badge'
    ].join(',');

    const normalize = (value) => value.replace(/\s+/g, ' ').trim();

    const originalText = (element) => normalize(Array.from(element.childNodes)
      .filter((node) => !(node.nodeType === Node.ELEMENT_NODE && node.classList.contains('aurea-vn-heading')))
      .filter((node) => !(node.nodeType === Node.ELEMENT_NODE && node.classList.contains('aurea-vn-supporting')))
      .map((node) => node.textContent)
      .join(' '));

    const appendTranslation = (element, translations, className) => {
      const sourceText = originalText(element);
      const translation = translations.get(sourceText);
      if (!translation) return;

      if (sourceText === 'Shop by Categories') {
        element.classList.add('aurea-bilingual--category-heading');
      }

      if (sourceText === 'America’s #1 Trusted Choice for All bussiness' || sourceText === "America's #1 Trusted Choice for All bussiness") {
        element.classList.add('aurea-bilingual--category-kicker');
      }

      if (element.querySelector(`:scope > .${className}`)) return;

      const vietnamese = document.createElement('span');
      vietnamese.className = className;
      vietnamese.lang = 'vi';
      vietnamese.textContent = translation;
      element.append(vietnamese);
    };

    const applyTranslations = (root = document) => {
      const headingElements = root.matches?.(headingSelector)
        ? [root, ...root.querySelectorAll(headingSelector)]
        : root.querySelectorAll(headingSelector);
      const supportingElements = root.matches?.(supportingSelector)
        ? [root, ...root.querySelectorAll(supportingSelector)]
        : root.querySelectorAll(supportingSelector);

      headingElements.forEach((element) => appendTranslation(element, headingTranslations, 'aurea-vn-heading'));
      supportingElements.forEach((element) => appendTranslation(element, supportingTranslations, 'aurea-vn-supporting'));
    };

    let scheduled = false;
    const scheduleApply = () => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        applyTranslations();
      });
    };

    const start = () => {
      applyTranslations();
      const observer = new MutationObserver(scheduleApply);
      observer.observe(document.body, { childList: true, subtree: true });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
